import React, {Component} from 'react';
import { Route, Switch } from 'react-router-dom';
import toastr from "toastr";
import RetinaImage from "react-retina-image";
import InputRegular from "../common/InputRegular";
import DateTime from './myProfile/DateTime';
import PersonalInfo from './myProfile/PersonalInfo';
import Security from './myProfile/Security';


class ApiSettings extends Component {
    state = {
        user: this.props.user,
        selectedSource: this.props.selectedSource,
        screen: 'settings',
        webhookURL: '',
        apiKeys: [],
        visibleKeys: [],
        hiddenKeys: [1, 2],
        activatedKeys: [1],
        pausedKeys: [2]
    }

    componentDidMount = () => {
        // console.log('component mounted')
    }

    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            await this.setState({
                selectedSource: this.props.selectedSource
            })
        }
        if((this.state.screen === 'settings')&&(window.location.pathname === '/api/logs') ){
            this.setState({screen: 'logs'})
        }else if((this.state.screen === 'logs')&&(window.location.pathname === '/api/settings') ){
            this.setState({screen: 'settings'})
        }
    }
    revealAPIKey = async (keyID) => {
        // console.log('keyID: ', keyID)
    }
    handleWebhookURL = async (inputValue) => {
        this.setState({
            webhookURL: inputValue
        })
    }

    handleKeyVisibility = async (index) => {
        //console.log('visibility - keyIndex: ', index)

        let visibleKeys = this.state.visibleKeys
        let hiddenKeys = this.state.hiddenKeys
        let keyIndex = ''
        if (visibleKeys.includes(index)) {
            keyIndex = visibleKeys.indexOf(index)
            if (keyIndex > -1) {
                visibleKeys.splice(keyIndex, 1);
            }
            hiddenKeys = [...hiddenKeys, index]
            await this.setState({
                visibleKeys,
                hiddenKeys
            })
        } else {
            visibleKeys = [...visibleKeys, index]
            keyIndex = hiddenKeys.indexOf(index)
            if (keyIndex > -1) {
                hiddenKeys.splice(keyIndex, 1);
            }
            this.setState({
                visibleKeys,
                hiddenKeys
            })
        }
    }

    handleKeyPause = async (index) => {
        let activatedKeys = this.state.activatedKeys
        let pausedKeys = this.state.pausedKeys
        let keyIndex = ''
        if (activatedKeys.includes(index)) {
            keyIndex = activatedKeys.indexOf(index)
            if (keyIndex > -1) {
                activatedKeys.splice(keyIndex, 1);
            }
            pausedKeys = [...pausedKeys, index]
            await this.setState({
                activatedKeys,
                pausedKeys
            })
        } else {
            activatedKeys = [...activatedKeys, index]
            keyIndex = pausedKeys.indexOf(index)
            if (keyIndex > -1) {
                pausedKeys.splice(keyIndex, 1);
            }
            this.setState({
                activatedKeys,
                pausedKeys
            })
        }
    }

    handleKeyRemove = async (index) => {
        // console.log('remove - keyIndex: ', index)
    }

    switchScreens = async (screen) => {
        // console.log('screen: ', screen)
        if(screen === 'settings'){
            this.props.history.push('/api/settings')
        }else{
            this.props.history.push('/api/logs')
        }
        await this.setState({
            screen
        })
    }

    copyToClipboard = (id) => {
        id = id.toString()
        let text = document.getElementById(id).innerText;
        let elem = document.createElement("textarea");
        document.body.appendChild(elem);
        elem.value = text;
        elem.select();
        document.execCommand("copy");
        document.body.removeChild(elem);
        toastr.success('ID copied to clipboard!')
    }

    renderSettings = () => {
        return <React.Fragment>
                <div id='api-keys' className="panel-container margin-top-20">
                    <div className="api-container">
                        <div className="display-flex justify-content-space margin-bottom-20">
                            <div className="f-16 text-bold uppercase">API access key</div>
                            <button className='btn-action'>+ Add access key</button>
                        </div>
                        <div className="api-key-container margin-bottom-20">
                            <div className="key-title active">new_api</div>
                            <div className="display-flex">
                                <div className="api-key">
                                    {
                                        this.state.hiddenKeys.includes(1) ?
                                            <RetinaImage
                                                onClick={() => this.revealAPIKey(1)}
                                                src={['/img/api-key.png', '/img/api-key@2x.png']}
                                                alt='Api Key Picture'
                                                checkIfRetinaImgExists={false}
                                            />
                                            :
                                            <React.Fragment>
                                                <p id='1'>1f60e8e6-9c1c-4e34-9b70-eb088054691a</p>
                                                <button onClick={() => this.copyToClipboard(1)}
                                                        className='btn-lite'>
                                                    <i className="fas fa-copy"></i>
                                                    Copy to clipboard
                                                </button>
                                            </React.Fragment>
                                    }
                                </div>
                                <div className="api-button-container">
                                    <button onClick={() => this.handleKeyVisibility(1)}
                                            className='btn-lite'>
                                        {this.state.visibleKeys.includes(1) ?
                                            'Hide API key'
                                            :
                                            'View API key'
                                        }
                                    </button>
                                    <button onClick={() => this.handleKeyPause(1)} className='btn-lite'>
                                        {this.state.pausedKeys.includes(1) ?
                                            'Activate key'
                                            :
                                            'Pause key'
                                        }
                                    </button>
                                    <button onClick={() => this.handleKeyRemove(1)} className='btn-lite'>Remove key
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="api-key-container">
                            <div className="key-title paused">another_api</div>
                            <div className="display-flex">
                                <div className="api-key">
                                    {
                                        this.state.hiddenKeys.includes(2) ?
                                            <RetinaImage
                                                onClick={() => this.revealAPIKey(1)}
                                                src={['/img/api-key.png', '/img/api-key@2x.png']}
                                                alt='Api Key Picture'
                                                checkIfRetinaImgExists={false}
                                            />
                                            :
                                            <React.Fragment>
                                                <p id='2'>1f60e8e6-9c1c-4e34-9b70-eb088054691a</p>
                                                <button onClick={() => this.copyToClipboard(2)}
                                                        className='btn-lite'>
                                                    <i className="fas fa-copy"></i>
                                                    Copy to clipboard
                                                </button>
                                            </React.Fragment>
                                    }
                                </div>
                                <div className="api-button-container">
                                    <button onClick={() => this.handleKeyVisibility(2)} className='btn-lite'>
                                        {this.state.visibleKeys.includes(2) ?
                                            'Hide API key'
                                            :
                                            'View API key'
                                        }
                                    </button>
                                    <button onClick={() => this.handleKeyPause(2)} className='btn-lite'>
                                        {this.state.pausedKeys.includes(2) ?
                                            'Activate key'
                                            :
                                            'Pause key'
                                        }
                                    </button>
                                    <button onClick={() => this.handleKeyRemove(2)} className='btn-lite'>Remove key
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className='muted-text'>
                        API Access Keys give you access to our REST API and all of its routes. <br/>
                        You can use the same key for multiple methods simultaneously.
                    </p>
                </div>

                <div id='status-reports-url' className="panel-container margin-top-20">
                    <div className="display-flex justify-content-space margin-bottom-20">
                        <div className="f-16 text-bold uppercase">Status reports url</div>
                    </div>
                    <div className="display-flex justify-content-space margin-bottom-30 api-container">
                        <div className='status-desc'>
                            <p className='f-16 margin-bottom-30'>
                                Configure the URL where the status reports of SMS messages need to be sent to.
                            </p>
                            <p className='f-16'>Note: enter the full address (including http://)</p>
                        </div>
                        <div className="webhook-url-container">
                            <InputRegular
                                id='webhook'
                                label1="Webhook URL"
                                label2=""
                                placeholder="Webhook URL"
                                type='text'
                                onChange={this.handleWebhookURL}
                                value={this.state.webhookURL}
                            />
                        </div>
                    </div>
                    <button className='btn-action'>Save changes</button>
                </div>
            </React.Fragment>
    }

    renderLogs = () => {
        return <React.Fragment>

        </React.Fragment>
    }


    render() {
        return (
            <React.Fragment>
                <h1 className='main-title'>API Settings</h1>
                <div className="display-flex justify-content-space api-settings-header">
                    <div className="tabs-navigation">
                        <div
                            className={this.state.screen === 'settings' ? "navigation-tab active" : 'navigation-tab'}
                            onClick={() => this.switchScreens('settings')}
                        >API Settings
                        </div>
                        <div className={this.state.screen === 'logs' ? "navigation-tab active" : 'navigation-tab'}
                             onClick={() => this.switchScreens('logs')}
                        >API Logs
                        </div>
                    </div>

                    <button className="btn-action">
                        <i className="far fa-file-alt"></i>
                        Read the API Docs
                    </button>

                </div>
                <Switch>
                    <Route path="/api/settings"
                           render={(props) =>
                               this.renderSettings()
                           }
                    />

                    <Route path="/api/logs"
                           render={(props) =>
                               this.renderLogs()
                           }
                    />
                </Switch>
            </React.Fragment>
        )
    }

}


export default ApiSettings